import MuiIconButton from '@mui/material/IconButton';
import { alpha, hexToRgb } from '@mui/system';

import { defaultTheme } from 'Theme';
import { styled } from 'helpers';

import { IconButtonProps } from '.';

const IconBtnColors = {
  dark: {
    focusBackGroundColor: alpha(hexToRgb(defaultTheme.palette.common.white), 0.24),
    hoverColor: defaultTheme.palette.blueGrey['A300'],
    hoverBackGroundColor: alpha(hexToRgb(defaultTheme.palette.common.white), 0.16),
  },
  light: {
    focusBackGroundColor: defaultTheme.palette.grey['A100'],
    hoverColor: defaultTheme.palette.blueGrey['A600'],
    hoverBackGroundColor: defaultTheme.palette.grey['A50'],
  },
};

// prettier-ignore
export const StyledIconButton = styled(MuiIconButton, { shouldForwardProp: (prop) => prop !== 'dark' })<IconButtonProps>`
  color: ${({ theme }) => theme.palette.blueGrey['A400']};
  
  &:hover {
    color: ${({ dark }) => IconBtnColors[dark ? 'dark' : 'light'].hoverColor};
    background-color: ${({ dark }) => IconBtnColors[dark ? 'dark' : 'light'].hoverBackGroundColor};
  }

  &:active,
  &.Mui-focusVisible {
    color: ${({ dark }) => IconBtnColors[dark ? 'dark' : 'light'].hoverColor};
    background-color: ${({ dark }) => IconBtnColors[dark ? 'dark' : 'light'].focusBackGroundColor};
  }

  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A100']};
  }

  &.MuiIconButton-sizeMedium {
     padding: 0;
   }

  &.MuiIconButton-sizeLarge {
    padding: 4px;
  }
`;
